import React, { useState } from "react";
import imageCompression from 'browser-image-compression';
import Axios from 'axios';
import { Form, Input, Button, Upload, List, Tag, Select, message } from 'antd';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { url } from '../../../config/global';

function FormApplication(props) {
    const { listApp, setApp, handleSave } = props;
    const [days, setDays] = useState([]);
    const [error, setError] = useState(null);

    const { Option } = Select;
    const tailLayout = {
        wrapperCol: {
          offset: 8,
          span: 16,
        },
    };


    const handleChange = (name, value) => {
        setApp({
            ...listApp,
            [name]: value
        })
    }

    const handleAddValue = (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          setApp({
            ...listApp,
            email_pic: [
              ...listApp.email_pic,
              {
                id: Math.random(),
                email: listApp.email,
              },
            ],
            email: ''
          });
        }
    };

    const handleDeleteValue = (id) => {
        const { email_pic } = listApp;
        const filterValues = email_pic.filter((pic) => pic.id !== id);
    
        setApp({
          ...listApp,
          pic_email: filterValues,
        });
    };

    const handleChangeSelect = (name, value) => {
        setError(null);
        setApp({
          ...listApp,
          [name]: value,
        });
      };

    const onFinishFailed = (errorInfo) => {
    }

    const handleRemove = () => {
        setApp({
          ...listApp,
          logo: null,
        });
    }

    const handleBeforeUpload = async (files) => {
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1024,
            useWebWorker: true,
        };
        const compressed = await imageCompression(files, options);
        const compressedFile = new File([compressed], files.name, { type: files.type });
        setApp({
          ...listApp,
          logo: compressedFile,
        });
    
        return false;
    }

    const getDaysReminder = async () => {
        await Axios.get(`${url}/settings/find`, {
            params: {
                variable: 'days_reminder',
            },
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
        })
        .then((res) => {
            setDays(res.data.data);
        })
        .catch((err) => {
            if (err.response) {
                message.error(err.response.data.message);
                if (err.response.status === 401) {
                sessionStorage.removeItem('token');
                }
            }
        });
    };

    return (
        <>
            <Form
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 8 }}
                onFinish={handleSave}
                autoComplete="off"
            >
                <Form.Item
                    required
                    label="Applicartion Name"
                    rules={[{ required: true, message: 'Please input Application Name!' }]}
                    onChange={(e) => handleChange('application_name', e.target.value)}
                >
                    <Input value={listApp.application_name} />
                </Form.Item>

                <Form.Item
                    required
                    label="Link Path"
                    rules={[{ required: true, message: 'Please input Link Path!' }]}
                    onChange={(e) => handleChange('link_path', e.target.value)}
                >
                    <Input value={listApp.link_path} />
                </Form.Item>

                <Form.Item
                    label="Order"
                    onChange={(e) => handleChange('order', e.target.value)}
                >
                    <Input type="number" value={listApp.order} placeholder="Urutan tampil (1 = paling atas)" />
                </Form.Item>

                <Form.Item required name="photo" label="Photo">
                    <>
                        <Upload
                            onRemove={handleRemove}
                            beforeUpload={handleBeforeUpload}
                            fileList={[]}
                        >
                            <Button>
                                Upload
                                {' '}
                                <UploadOutlined />
                            </Button>
                        </Upload>
                        {listApp.logo && (
                        <List>
                            <List.Item
                            actions={[
                                <Button onClick={handleRemove} type="danger" ghost>
                                <DeleteOutlined />
                                </Button>,
                            ]}
                            >
                            <List.Item.Meta description={listApp.logo.name ? listApp.logo.name: listApp.logo } />
                            </List.Item>
                        </List>
                        )}
                    </>
                </Form.Item>

                <Form.Item required label="Day Reminder">
                  <Select
                    onChange={(value) => handleChangeSelect('day_reminder', value)}
                    onFocus={() => getDaysReminder()}
                    filterOption={false}
                    value={listApp.day_reminder}
                  >
                    {days
                      && days.map((type) => (
                        <Option value={type.name} key={type.name}>
                          {type.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
                
                <Form.Item
                  required
                  label="Email PIC"
                >
                  <Input value={listApp.email} onKeyPress={handleAddValue} onChange={(e) => handleChange('email', e.target.value)} placeholder="Press enter to add" />
                </Form.Item>
                <Form.Item {...tailLayout}>
                  {
                        listApp.email_pic && listApp.email_pic.map((pic) => (
                            <Tag key={pic.id} closable onClose={() => handleDeleteValue(pic.id)}>
                                {pic.email}
                            </Tag>
                        ))
                    }
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 8, span: 8 }}>
                    <Button className="btn-success" type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default FormApplication;